// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "all-260211-0/static/css/" + chunkId + "." + "abc7f78e" + ".chunk.css";
};